import React from 'react';
import { useNavigate } from 'react-router-dom';

// Row actions per list (approved mockups): HM / Admin — View, Edit, Close (open / on hold) or Delete (draft / in
// approval — the only trash icon) · Recruiter — View, Search (candidate search for the job) · Team — View + Assign /
// Hand to lead / Recruit myself / Reassign. Search shows in every view for people with Recruit who can work the job
// (row.actions.search — the server's can_work_job).
// Only what the API allows (row.actions) is offered. onDialog(kind, job) opens a dialog.
const ICON = {
  view: <><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>,
  edit: <path d="M4 20h4L19 9l-4-4L4 16v4z" />,
  delete: <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />,
  close: <path d="M4 7h16v13H4zM9 11h6M2 4h20v3H2z" />,
  search: <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></>,
};
export function IconBtn({ kind, label, onClick, disabled, danger }) {
  return (
    <button type="button" onClick={onClick} disabled={disabled} aria-label={label} title={label}
      className={`w-9 h-9 rounded-[10px] border border-[#E6E9F0] bg-white inline-flex items-center justify-center disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#F5F7FB] ${danger ? 'text-[#B91C1C]' : 'text-[#334155]'}`}>
      <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">{ICON[kind]}</svg>
    </button>
  );
}

const textBtn = 'inline-flex items-center min-h-[36px] px-3 rounded-[10px] text-[13px] font-semibold whitespace-nowrap';

export default function JobActions({ view, row, onDialog }) {
  const navigate = useNavigate();
  const a = row.actions || {};
  const open = () => navigate(`/jobs/${row.id}`);
  const edit = () => {
    if (row.status === 'draft' && row.intake_id) navigate(`/jobs/intake/${row.intake_id}`);
    else if (a.change) onDialog('change', row);
    else open();
  };
  const label = row.job_title;
  const search = a.search && <IconBtn kind="search" label={`Find candidates for ${label}`} onClick={() => navigate(`/jobs/${row.id}/candidates`)} />;
  if (view === 'recruiter') {
    return (
      <div className="flex gap-1.5">
        <IconBtn kind="view" label={`View ${label}`} onClick={open} />
        {search || (!['open', 'on_hold'].includes(row.status)                  // closed etc.: shown disabled; not on the job: hidden
          && <IconBtn kind="search" label="Candidate search isn’t available for this job" disabled />)}
      </div>
    );
  }
  if (view === 'team') {
    return (
      <div className="flex flex-wrap gap-1.5 items-center">
        <IconBtn kind="view" label={`View ${label}`} onClick={open} />
        {search}
        {a.recruit_myself && !a.reassign && <button type="button" className={`${textBtn} border border-[#D9DEE8] bg-white`} onClick={() => onDialog('myself', row)}>Recruit myself</button>}
        {a.assign && <button type="button" className={`${textBtn} bg-[#0066CC] text-white`} onClick={() => onDialog('assign', row)}>Assign</button>}
        {a.hand_off && <button type="button" className={`${textBtn} border border-[#D9DEE8] bg-white`} onClick={() => onDialog('hand_off', row)}>Hand to lead</button>}
        {a.reassign && <button type="button" className={`${textBtn} border border-[#D9DEE8] bg-white`} onClick={() => onDialog('reassign', row)}>Reassign</button>}
      </div>
    );
  }
  return (
    <div className="flex gap-1.5">
      <IconBtn kind="view" label={`View ${label}`} onClick={open} />
      {search}
      {(a.edit || a.change) && <IconBtn kind="edit" label={`Edit ${label}`} onClick={edit} />}
      {a.close && !a.delete && <IconBtn kind="close" label={`Close ${label}`} onClick={() => onDialog('close', row)} />}
      {a.delete && <IconBtn kind="delete" danger label={`Delete ${label}`} onClick={() => onDialog('delete', row)} />}
    </div>
  );
}
